import React from "react";

function MovieDetail(props) {
    return (
        <div className="text-center">
            <img alt={props.title} className="img-fluid" src={props.src} style={{ margin:"0 auto" }} />
            <h3 id="released">Released: {props.released}</h3>
            <h3>Rated: {props.rated}</h3>
            <h3>Genre: {props.genre}</h3>
            <h3>Actors: {props.actors}</h3>
            <h3>Director: {props.director}</h3>
            <h3 id="runtime">Run Time: {props.runtime}</h3>
            <br />
            <h3 id ="plot">{props.plot}</h3>
            
        </div>
    );
}

export default MovieDetail;